module.exports = __webpack_public_path__ + "img/rmpp.632070c2.png";